import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const api = axios.create({ baseURL: API });

api.interceptors.request.use((config) => {
  const token = localStorage.getItem("mpl_token");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  const actAs = localStorage.getItem("mpl_act_as");
  const url = config.url || "";
  if (actAs && !url.includes("/auth/me") && !url.includes("/auth/login")) {
    config.headers["X-Act-As-Agent"] = actAs;
  }
  return config;
});

export function formatApiError(detail) {
  if (detail == null) return "Something went wrong. Please try again.";
  if (typeof detail === "string") return detail;
  if (Array.isArray(detail))
    return detail
      .map((e) => (e && typeof e.msg === "string" ? e.msg : JSON.stringify(e)))
      .filter(Boolean)
      .join(" ");
  if (detail && typeof detail.message === "string") return detail.message;
  if (detail && typeof detail.msg === "string") return detail.msg;
  return String(detail);
}

export const money = (v) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", maximumFractionDigits: 0 }).format(
    Number(v || 0)
  );

export const moneyCents = (v) =>
  new Intl.NumberFormat("en-US", { style: "currency", currency: "USD" }).format(Number(v || 0));

// Live comma formatting for dollar text inputs
export const fmtInput = (s) => {
  const raw = String(s ?? "").replace(/[^0-9.]/g, "");
  if (raw === "") return "";
  const [i, ...rest] = raw.split(".");
  const intPart = Number(i || 0).toLocaleString("en-US");
  return rest.length ? `${intPart}.${rest.join("").slice(0, 2)}` : intPart;
};
export const toNum = (s) => {
  const n = parseFloat(String(s ?? "").replace(/[^0-9.]/g, ""));
  return isNaN(n) ? 0 : n;
};

export default api;
